import.meta.glob("./seo_fields_manager/*.{js,hbs,jst.ejs}", { eager: true });
import "./thumbnail_editor.js";
import "./thumbnail_editor_modal.js";
import "../../shared/components/wizard_modal.js";
import "../../embed/events.js";
import "../config.js";
import "../../../../../lib/assets/javascripts/assert.js";

// Requires Sparkle.SEOAnalyzer from frontend

// VITE_MIGRATION: Preserve sub-properties (SnippetModal, etc.) attached by
// import.meta.glob above, which runs BEFORE this assignment under ES modules.
var __previousSEOFieldsManager = window.SEOFieldsManager;
window.SEOFieldsManager = function (
  resource,
  parentForm,
  seoContainer,
  snippetContainer,
  previewContainer,
  currentKeyword,
  options,
) {
  options = jQuery.extend(
    {
      exceptAnalysis: [],
    },
    options,
  );

  var selectors = jQuery.extend(
    {},
    {
      iframe: "#page-preview",
      content: "article", // Where to get the page text from
      removeContent: "script, style, input, source, svg, .field-input", // Elements to remove
      stripContent: "div, picture", // Elements to remove, but whose content should stay
      textlessContent: "img", // Textless elements that we still want to analyse
      pathOverrideInput: '[data-behaviour~="seo-snippet-url-input"]',
      seoContentScores: ".seo-content-category",
      seoRatings: ".seo-ratings",
    },
    Sparkle.Config.SEOFieldsManager.selectors,
    options.selectors,
  );

  var assert = new Asserter({ userMessage: "Error performing SEO Analysis" });

  var form = assert.element(parentForm);
  var container = assert.element(seoContainer);
  snippetContainer = assert.element(snippetContainer);

  var snippetModal = new SEOFieldsManager.SnippetModal();

  var yoastAnalysisMap = {
    na: "feedback",
    bad: "problems",
    ok: "improvements",
    good: "good results",
  };
  var busyIndicator = jQuery('<div class="seo-busy-indicator">');
  var defaultMap = container.data("seo-field-default-map");
  var defaultTemplates = container.find("#seo_defaults_fields template");

  var pathOverrideInput = form.find(selectors.pathOverrideInput);
  var baseURL = jQuery("<a>", { href: resource.publicUrl }).prop("host");
  var sparkleLinkPattern = new RegExp(window.Sparkle.Config.SEOFieldsManager.sparkleLinkPattern, "g");

  var thumbnailEditor = new ThumbnailEditor({
    aspectRatio: window.Sparkle.Config.SEOFieldsManager.thumbnailAspectRatio,
    responsive: false,
  });
  var thumbnailModal = new Sparkle.ThumbnailEditorModal(thumbnailEditor, "Edit Preview Image");
  var snippetPreview = new SEOSnippetPreview(resource);

  var lastPreviewContent;
  var currentPlatform;
  var platform;
  var seoAnalyzer;

  var publicInterface = {};

  // BEHAVIOUR

  container.on("change", "[data-platform]", handlePlatformChange);
  container.on("click", '[data-behaviour~="edit-snippet"]', handleEditClicked);
  container.on("yoast:beginAnalysis", showIndicator);
  container.on("yoast:endAnalysis", handleEndAnalysis);
  jQuery(window).on("seokeyword:change", handleKeywordChanged);
  jQuery(snippetModal).on("complete", handleSnippetUpdated);
  jQuery(snippetModal).on("cancel", handleSnippetCanceled);
  jQuery.each(defaultMap, function (key, value) {
    // Track each linked sparkle form field for changes
    getDefaultInput(key).on("input", updateSnippetPreview);
    getDefaultInput(key).on("change", function () {
      if (seoAnalyzer && isAnalysisStale) {
        seoAnalyzer.refresh();
      }
    });
  });
  pathOverrideInput.on("input", updateSnippetPreview);
  jQuery(window).on("pagebuilder:ready", function () {
    if (seoAnalyzer) {
      seoAnalyzer.refresh();
    }
  });
  jQuery(window).one("pagebuilder:ready", function () {
    // When the pagebuilder is ready, we know the iframe is loaded so it is safe to listen for embedded components completing
    Sparkle.Embed.Events.onComponentReady(getIframeDocument(), function () {
      if (seoAnalyzer) {
        seoAnalyzer.refresh();
      }
    });
  });

  jQuery(container).on("click", '[data-behaviour~="edit-snippet-thumbnail"]', handleThumbnailPreviewImageClick);
  jQuery(thumbnailModal).on("complete", handleThumbnailModalComplete);
  jQuery(thumbnailModal).on("cancel", handleThumbnailModalCancel);
  jQuery(thumbnailEditor).on("idle", handleThumbnailEditorIdle);
  jQuery(thumbnailEditor).on("busy", handleThumbnailEditorBusy);

  // EVENT HANDLERS

  function handlePlatformChange(event) {
    setPlatformFromElement(this);
    updateSeoAnalyzerFromPlatform(currentPlatform);
    seoAnalyzer.refresh();
  }

  function handleEditClicked(event) {
    loadSnippetFields();
    snippetModal.setOptions({
      header: "Edit " + currentPlatform.title + " Snippet",
      targets: currentPlatform.targets,
      thresholds: platform.thresholds,
    });
    snippetModal.show();
  }

  function handleKeywordChanged(event, keyword) {
    currentKeyword = keyword;
    seoAnalyzer.refresh();
  }

  function handleSnippetUpdated(event) {
    recordSnippetFields();
    updateSnippetPreview();
    seoAnalyzer.refresh();
  }

  function handleSnippetCanceled(event) {}

  function handleEndAnalysis(event) {
    hideIndicator();
    renderAnalysis();
  }

  function handleThumbnailPreviewImageClick(event) {
    thumbnailModal.show();
  }

  function handleThumbnailModalComplete(event) {
    recordPlatformThumbnail();
    updateSnippetPreviewThumbnail();
  }

  function handleThumbnailModalCancel(event) {
    updateThumbnail();
  }

  function handleThumbnailEditorIdle() {
    thumbnailModal.enableCompletion();
  }

  function handleThumbnailEditorBusy() {
    thumbnailModal.disableCompletion();
  }

  // HELPER FUNCTIONS

  function recordPlatformThumbnail() {
    getSEOInput("thumbnail").val(thumbnailEditor.getThumbnailJSON());
  }

  function updateSeoAnalyzerFromPlatform(platform) {
    seoAnalyzer.setOptions({ targets: platform.targets, thresholds: platform.thresholds });
  }

  // Update the snippet with the current platform's SEO form field values
  function loadSnippetFields() {
    var placeholders = computeSnippetPlaceholders();
    snippetModal.titleInput.val(getSEOInput("title").val()).attr("placeholder", placeholders.title).trigger("change");

    if (!placeholders.metaDesc) {
      snippetModal.descriptionInput.attr(
        "data-default-placeholder",
        currentPlatform.title +
          " will automatically generate the meta description from page content. It may not appear exactly as shown in the preview.",
      );
    } else {
      snippetModal.descriptionInput.removeAttr("data-default-placeholder");
    }

    snippetModal.descriptionInput
      .val(getSEOInput("description").val())
      .attr("placeholder", placeholders.metaDesc)
      .trigger("change");
  }

  // Update the current platform's SEO form fields
  function recordSnippetFields() {
    getSEOInput("title").val(snippetModal.titleInput.val());
    getSEOInput("description").val(snippetModal.descriptionInput.val());
  }

  function showIndicator() {
    busyIndicator.addClass("visible");
  }

  function hideIndicator() {
    busyIndicator.removeClass("visible");
  }

  function renderAnalysis() {
    var scores = seoAnalyzer.analysis.scores;
    var sortedRatings = sortRatings(scores);
    triggerRatingsUpdate(sortedRatings);
    renderAssessmentResults(seoAnalyzer.analysis.content);
    renderRatings(sortedRatings.types);
  }

  function renderAssessmentResults(assessmentResults) {
    var wrapper = container.find(selectors.seoContentScores).empty();

    assessmentResults.forEach(function (result) {
      if (result._identifier !== "fleschReadingEase") {
        return;
      }
      var renderer = new SEOFieldsManagerRatingsRenderer([result], { title: "Flesch Reading Ease" });
      wrapper.append(renderer.render().el);
    });
  }

  function setPlatformFromElement(element) {
    element = jQuery(element);

    platform = snippetPreview.platforms[element.data("platform")];

    assert.condition(platform.id && platform.title, "SEO Platform not detected");
    element.prop("checked", true);
    currentPlatform = platform;

    updateThumbnail().then(function () {
      snippetPreview.setData({ platform: currentPlatform.id });
      updateSnippetPreviewThumbnail();
      updateSnippetPreview();
    });

    container.trigger("seoFieldsManager:platformChange", [currentPlatform]);
  }

  function updateThumbnail() {
    return thumbnailModal.setThumbnail(getThumbnail(), { defaultThumbnail: getDefaultThumbnail() });
  }

  function getThumbnail() {
    var thumbnail = getSEOInput("thumbnail", { allowNull: true }).val();

    if (thumbnail) {
      return JSON.parse(thumbnail);
    }
  }

  function getDefaultThumbnail() {
    var thumbnail = getDefaultInput("thumbnail").val();

    if (thumbnail) {
      return JSON.parse(thumbnail);
    }
  }

  function updateSnippetPreviewThumbnail() {
    snippetPreview.setData({ thumbnail: thumbnailEditor.getPreviewUrl() || null });
  }

  function updateSnippetPreview() {
    var snippetData = computeSnippetData();
    snippetPreview.setData({ title: snippetData.title, description: snippetData.metaDesc, url: snippetData.urlPath });
  }

  function sortRatings(data) {
    var lookup = {},
      types = [];

    jQuery.each(yoastAnalysisMap, function (className, label) {
      var type = { label: yoastAnalysisMap[className], className: className, ratings: [] };
      types.push((lookup[className] = type));
    });

    jQuery.each(data, function (index, rating) {
      if (rating.className in lookup && isAnalysisWanted(rating.identifier)) {
        lookup[rating.className].ratings.push(rating);
      }
    });

    return { types: types, lookup: lookup };
  }

  function isAnalysisWanted(identifier) {
    return options.exceptAnalysis.indexOf(identifier) == -1;
  }

  function renderRatings(types) {
    var wrapper = container.find(selectors.seoRatings).empty();

    types.forEach(function (type) {
      var renderer = new SEOFieldsManagerRatingsRenderer(type.ratings, {
        title: type.label,
        className: type.className,
        count: true,
      });
      wrapper.append(renderer.render().el);
    });
  }

  function triggerRatingsUpdate(ratings) {
    jQuery(publicInterface).trigger("ratingsUpdate", [ratings]);
  }

  function computeAnalysisData() {
    return {
      text: getPreviewContent(),
      keyword: currentKeyword,
      permalink: getPermalink(),
    };
  }

  function computeSnippetData() {
    return {
      title: getSEOInput("title").val() || getDefaultInput("title").val() || "",
      metaDesc: getSEOInput("description").val() || getDefaultInput("description").val() || "",
      urlPath: pathOverrideInput.val() || pathOverrideInput.attr("placeholder") || resource.publicPath || "",
    };
  }

  function computeSnippetPlaceholders() {
    return {
      title: getDefaultInput("title").val() || "",
      metaDesc: getDefaultInput("description").val() || "",
      urlPath: pathOverrideInput.attr("placeholder") || "",
    };
  }

  function getPermalink() {
    var pathOverride = pathOverrideInput.val();
    return pathOverride ? "http://" + baseURL + pathOverride : resource.publicUrl;
  }

  function getPreviewContent() {
    var html = "";
    var iframe = jQuery(selectors.iframe);

    if (iframe.length) {
      var content = jQuery(getIframeDocument().body).find(selectors.content);
      html = optimizeDocument(content).html() || "";

      // Convert sparkle links to real ones so link analysis can be performed
      html = html.replace(sparkleLinkPattern, "http://" + baseURL + "/");
    }

    return (lastPreviewContent = html);
  }

  function getIframeDocument() {
    return jQuery(selectors.iframe).prop("contentWindow").document;
  }

  // Simplify the document to make analysis faster. Speed seems to be determined by the number of elements, not bytesize.
  function optimizeDocument(content) {
    content = content.clone();
    content.find(selectors.removeContent).remove();
    var contentElements = content.find("*");
    removeTextlessElements(contentElements);
    stripElements(contentElements);

    return content;
  }

  function removeTextlessElements(elements) {
    var el;
    elements.each(function () {
      el = jQuery(this);
      if (el.find(selectors.textlessContent) || el.is(selectors.textlessContent)) {
        return;
      } else if (jQuery.trim(el.text())) {
        return;
      } else {
        el.remove();
      }
    });
  }

  function stripElements(elements) {
    var el;
    elements.each(function () {
      el = jQuery(this);
      if (el.is(selectors.stripContent)) {
        el.replaceWith(el.children());
      }
    });
  }

  function isAnalysisStale() {
    return lastPreviewContent !== getPreviewContent();
  }

  // Look up the form input from which to get the default value of the given key
  function getDefaultInput(key) {
    return form.find(defaultMap[key]).last(); // Support hidden "default" fields
  }

  // Look up the form input into which the given key should be saved
  function getSEOInput(key, options) {
    options = jQuery.extend({ allowNull: false }, options);
    var pattern = window.Sparkle.Config.SEOFieldsManager.metadataPattern;
    var name = pattern.replace("%{platform}", currentPlatform.id).replace("%{key}", key);
    var input = form.find('[name$="[' + name + ']"]').last(); // Support hidden "default" fields

    if (!options.allowNull) {
      assert.condition(input.length, "SEO Field '" + name + "' not detected");
    }

    return input;
  }

  // Allow default SEO values to be read by inserting a field for attributes that don't already exist in the form
  function appendDefaultInputs() {
    defaultTemplates.each(function () {
      var input = jQuery(this.content.cloneNode(true)).find("input");
      var name = jQuery(input).attr("name");
      var matches = form.find('[name="' + name + '"]');

      if (!matches.length) {
        jQuery(this).after(input);
      }
      jQuery(this).remove();
    });
  }

  // INITIALIZE

  appendDefaultInputs();
  setPlatformFromElement(container.find("[data-platform]").first());
  snippetPreview.el.appendTo(previewContainer);
  seoAnalyzer = new Sparkle.SEOAnalyzer({
    outputContainer: seoContainer.attr("id"),
    analysisDataFn: computeAnalysisData,
    snippetDataFn: computeSnippetData,
    assessments: ["fleschReadingEase"],
    introductionKeyword: {
      contextDecorator: function (text, paragraph) {
        return (
          text +
          "<a class='info-link' data-tooltip='The first paragraph detected on this page is: \n\n \"" +
          paragraph +
          "\"'></a>"
        );
      },
    },
  });
  updateSeoAnalyzerFromPlatform(currentPlatform);
  container.append(busyIndicator);

  // PUBLIC INTERFACE

  return jQuery.extend(publicInterface, {
    isAnalysisStale: isAnalysisStale,
    refreshAnalysis: seoAnalyzer.refresh,
  });
};

// Re-attach properties (SnippetModal, etc.) from the glob-imported submodules
// that ran before the assignment above.
if (__previousSEOFieldsManager) {
  Object.assign(window.SEOFieldsManager, __previousSEOFieldsManager);
}
